import { render, staticRenderFns } from "./contributionIndex1.vue?vue&type=template&id=1c38ea31&scoped=true&"
import script from "./contributionIndex1.vue?vue&type=script&lang=js&"
export * from "./contributionIndex1.vue?vue&type=script&lang=js&"
import style0 from "./contributionIndex1.vue?vue&type=style&index=0&id=1c38ea31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c38ea31",
  null
  
)

export default component.exports